import PropTypes from 'prop-types';
import React from 'react';

function InternalPanelListItem(props) {
  const { show, children } = props;
  if (!show) {
    return null;
  }

  return (
    <div className="tabbed-content__panel-list-item">
      { children }
    </div>
  );
}

InternalPanelListItem.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

InternalPanelListItem.defaultProps = {
  show: false,
};

export default InternalPanelListItem;
